import modal from '../patterns/modal.js';
import PL_utils from '../patterns/pl-utils.js';
import $ from 'jquery';
window.jQuery = $;

/* eslint-disable */

const isEDMode = window.location.href.indexOf('ed=1') > -1;
var instantiatedByEl = false;

var modalHooks = {
  _hasScrolledToBottom: false,
  _addModalError: function (target) { },
  _removeModalError: function (target) { },
  beforeOpen: function () {
    return false;
  },
  afterOpen: function (target) {
    var hooks = this;
    var modalContent = target.querySelector('.modal__body');
    var errorMessage = target.querySelector('.continued-required');

    PL_utils.addClass("hidden", errorMessage);
    // Reset Modal state.  Resetting scroll flag, modal button class, and scroll position.
    modalContent.scrollTop = 0;
    var hooks = this;
    hooks._hasScrolledToBottom = false;

    if (!isEDMode) {
      window.eventsManager.emit("showModal", { type: "disclaimer", params: "" });
    }
  },
  onContinue: function (e, target) {

  },
  onCancel: function () {
    return false;
  },
  beforeClose: function () {
    const isActive = document.querySelector('.modal-disclaimer.modal--active');
    document.querySelectorAll('.modal').forEach((item) => {
      if (!item.getAttribute("hidden")) {
        item.setAttribute('hidden', "");
        item.setAttribute("aria-hidden", true);
      }
    });
    if (!isEDMode && isActive) {
      window.eventsManager.emit("hideModal", { type: "disclaimer", params: "" });
    }
    return false;
  },
  afterClose: function () {
    if (instantiatedByEl) {
      instantiatedByEl.querySelector("input").focus();
      instantiatedByEl = false;
    }
    return false;
  },
  setSize: function () {
    return false
  },
  onScreenshot: function () {
    return false
  },
  onInit: function (target) { }
}


const appplyAccessibility = (ModalEle) => {
  var el_label = ModalEle.querySelector("[data-label]");
  if (el_label != null && !isEDMode) {
    ModalEle.setAttribute("aria-label", el_label.innerHTML);
    ModalEle.setAttribute("role", "dialog");
    ModalEle.setAttribute("aria-modal", "true");
    ModalEle.removeAttribute("hidden");
    ModalEle.removeAttribute("aria-hidden");
    ModalEle.setAttribute("tabIndex", "0");
  }
};


var disclaimerEle = document.querySelector('.modal-disclaimer');
var disclaimerModal = modal.initModal(disclaimerEle, modalHooks);
var errorNodes = document.querySelector('.modal-fatp-form .form-error');


const publicInterface = {
  init: function () {
    //screenshot
    if (isEDMode) {
      if (window.location.search.substring(1).split('&').indexOf('modal=disclaimer-1') > -1) {
        disclaimerModal.showModal();
        PL_utils.addClass("active", errorNodes);
      }
      if (window.location.search.substring(1).split('&').indexOf('modal=disclaimer-2') > -1) {
        //full modal
        disclaimerModal.showModal();
        PL_utils.addClass('full-height', disclaimerEle);
        PL_utils.removeClass('hidden', errorNodes);
      }
    }
  },
  showModal: function (e) {
    document.getElementById('fatp-continue').checked = false;
    instantiatedByEl = e.target.parentElement;
    appplyAccessibility(disclaimerEle);
    disclaimerModal.showModal();
    disclaimerEle.focus();
  }
}

export default publicInterface;
